import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { select } from "d3-selection"

class Axis extends Component {
  static propTypes = {
    fn: PropTypes.func.isRequired,
    transform: PropTypes.string.isRequired,
    className: PropTypes.string,
  }

  draw = () => {
    const { ref, props: { fn } } = this

    select(ref)
      .call(fn)
  }

  componentDidUpdate() {
    this.draw()
  }

  setRef = node => {
    this.ref = node
    this.draw()
  }

  render() {
    const { transform, className } = this.props
    return <g ref={this.setRef} className={classNames("axis", className)} transform={transform} />
  }
}

export default Axis
